webpackJsonp([1],{

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(1118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Kanban', {
    attrs: {
      "stages": _vm.statuses,
      "blocks": _vm.blocks
    },
    on: {
      "update-block": _vm.updateBlock
    }
  }, [_vm._l((_vm.statuses), function(stage) {
    return _c('div', {
      key: stage,
      slot: stage
    }, [_c('h2', [_vm._v("\n        " + _vm._s(stage) + "\n        "), _c('a', [_vm._v("+")])])])
  }), _vm._v(" "), _vm._l((_vm.blocks), function(item) {
    return _c('div', {
      key: item.id,
      slot: item.id
    }, [_c('div', [_c('strong', [_vm._v("id:")]), _vm._v(" " + _vm._s(item.id) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(item.title) + "\n      ")])])
  }), _vm._v(" "), _vm._l((_vm.statuses), function(stage) {
    return _c('div', {
      key: stage,
      slot: ("footer-" + stage)
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          (function () { return _vm.addBlock(stage); })($event)
        }
      }
    }, [_vm._v("+ Add new block")])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h4', [_vm._v("\n      Vue adoptation of Ettric's\n      "), _c('a', {
    attrs: {
      "href": "//codepen.io/ettrics/pen/QbPEeg"
    }
  }, [_vm._v("Codepen")])])])
}]}

/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-container"
  }, [_c('ul', {
    staticClass: "drag-list"
  }, _vm._l((_vm.stages), function(stage) {
    return _c('li', {
      key: stage,
      staticClass: "drag-column",
      class: ( _obj = {}, _obj['drag-column-' + stage] = true, _obj )
    }, [_c('span', {
      staticClass: "drag-column-header"
    }, [_vm._t(stage, [_c('h2', [_vm._v(_vm._s(stage))])])], 2), _vm._v(" "), _c('div', {
      staticClass: "drag-options"
    }), _vm._v(" "), _c('ul', {
      ref: "list",
      refInFor: true,
      staticClass: "drag-inner-list",
      attrs: {
        "data-status": stage
      }
    }, _vm._l((_vm.getBlocks(stage)), function(block) {
      return _c('li', {
        key: block[_vm.idProp],
        staticClass: "drag-item",
        attrs: {
          "data-block-id": block[_vm.idProp]
        }
      }, [_vm._t(block[_vm.idProp], [_c('strong', [_vm._v(_vm._s(block[_vm.statusProp]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(block[_vm.idProp]))])])], 2)
    })), _vm._v(" "), _c('div', {
      staticClass: "drag-column-footer"
    }, [_vm._t(("footer-" + stage))], 2)])
    var _obj;
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(1117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Kanban__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Kanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Kanban__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Kanban: __WEBPACK_IMPORTED_MODULE_2__components_Kanban___default.a
  },
  data: function data() {
    return {
      statuses: ['on-hold', 'in-progress', 'needs-review', 'approved'],
      blocks: []
    };
  },
  mounted: function mounted() {
    for (var i = 0; i <= 10; i += 1) {
      this.blocks.push({
        id: i,
        status: this.statuses[Math.floor(Math.random() * 4)],
        title: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.company.bs()
      });
    }
  },


  methods: {
    updateBlock: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (id, status) {
      this.blocks.find(function (b) {
        return b.id === Number(id);
      }).status = status;
    }, 500),
    addBlock: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (stage) {
      this.blocks.push({
        id: this.blocks.length,
        status: stage,
        title: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.company.bs()
      });
    }, 500)
  }
});

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dragula__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dragula___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dragula__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xstate__ = __webpack_require__(1125);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KanbanBoard',

  props: {
    stages: {
      type: Array,
      required: true
    },
    blocks: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    stateMachineConfig: {
      type: Object,
      default: null
    },
    idProp: {
      type: String,
      default: 'id'
    },
    statusProp: {
      type: String,
      default: 'status'
    }
  },

  data: function data() {
    return {
      machine: null
    };
  },


  computed: {
    localBlocks: function localBlocks() {
      return this.blocks;
    }
  },

  methods: {
    getBlocks: function getBlocks(status) {
      var _this = this;

      return this.localBlocks.filter(function (block) {
        return block[_this.statusProp] === status;
      });
    },
    findPossibleTransitions: function findPossibleTransitions(sourceState) {
      return this.machine.config.states[sourceState].on || {};
    },
    findTransition: function findTransition(target, source) {
      var targetState = target.dataset.status;
      var sourceState = source.dataset.status;
      var possibleTransitions = this.findPossibleTransitions(sourceState);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(possibleTransitions).find(function (transition) {
        return possibleTransitions[transition] === targetState;
      });
    },
    accepts: function accepts(block, target, source) {
      if (!this.machine) return true;
      var targetState = target.dataset.status;
      var sourceState = source.dataset.status;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.findPossibleTransitions(sourceState)).includes(targetState);
    },
    allowedTargets: function allowedTargets(el, source) {
      var _this2 = this;

      var block = this.localBlocks.find(function (b) {
        return b[_this2.idProp] === el.dataset.blockId;
      });
      return this.drake.containers.filter(function (c) {
        return _this2.config.accepts(block, c, source);
      });
    },
    forbiddenTargets: function forbiddenTargets(el, source) {
      var _this3 = this;

      return this.drake.containers.filter(function (c) {
        return !_this3.allowedTargets(el, source).includes(c);
      });
    }
  },

  updated: function updated() {
    this.drake.containers = this.$refs.list;
    this.drake.mirrorContainer = this.$el;
  },
  mounted: function mounted() {
    var _this4 = this;

    this.config.accepts = this.config.accepts || this.accepts;
    this.config.mirrorContainer = this.$el;
    this.drake = __WEBPACK_IMPORTED_MODULE_2_dragula___default()(this.$refs.list, this.config).on('drag', function (el, source) {
      _this4.$emit('drag', el, source);
      el.classList.add('is-moving');
      _this4.allowedTargets(el, source).forEach(function (c) {
        return c.classList.add('allowed');
      });
      _this4.forbiddenTargets(el, source).forEach(function (c) {
        return c.classList.add('forbidden');
      });
    }).on('dragend', function (el) {
      _this4.$emit('dragend', el);
      el.classList.remove('is-moving');
      _this4.drake.containers.forEach(function (c) {
        return c.classList.remove('allowed', 'forbidden');
      });
      window.setTimeout(function () {
        el.classList.add('is-moved');
        window.setTimeout(function () {
          el.classList.remove('is-moved');
        }, 600);
      }, 100);
    }).on('drop', function (block, list, source, sibling) {
      _this4.$emit('drop', block, list, source, sibling);
      var index = 0;
      for (index = 0; index < list.children.length; index += 1) {
        if (list.children[index].classList.contains('is-moving')) break;
      }

      var newState = list.dataset.status;

      if (_this4.machine) {
        var transition = _this4.findTransition(list, source);
        if (!transition) return;
        newState = _this4.machine.transition(source.dataset.status, transition).value;
      }

      _this4.$emit('update-block', block.dataset.blockId, newState, index);
    }).on('cancel', function (el, container, source) {
      _this4.$emit('cancel', el, container, source);
    }).on('remove', function (el, container, source) {
      _this4.$emit('remove', el, container, source);
    }).on('shadow', function (el, container, source) {
      _this4.$emit('shadow', el, container, source);
    }).on('over', function (el, container, source) {
      _this4.$emit('over', el, container, source);
    }).on('out', function (el, container, source) {
      _this4.$emit('out', el, container, source);
    }).on('cloned', function (clone, original, type) {
      _this4.$emit('cloned', clone, original, type);
    });
    this.$emit('init', this.drake);
  },
  created: function created() {
    if (!this.stateMachineConfig) return;
    this.machine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_xstate__["a" /* Machine */])(this.stateMachineConfig);
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[24]);


// WEBPACK FOOTER //
// static/js/app.e7372a210e39ab0b1c05.js